import { CircularProgress } from "@mui/material";

function Loading() {
  return (
    <div className="flex justify-center items-center h-screen">
      <CircularProgress size={36} color="primary" />
    </div>
  );
}

export default Loading;
